/**
 Usage:
 const newObj = mapObject(existing, key => key+1, value => value+1);
 */
export function mapObject(object, keyMapper, valueMapper) {
  const newObject = {};
  loopObject(object, (key, value) => {
    newObject[keyMapper(key)] = valueMapper(value);
  });
  return newObject;
}

export function loopObject(object, entryMapper) {
  return Object.keys(object).map((key) => {
    const value = object[key];
    return entryMapper(key, value);
  });
}
